import React from 'react'
import { IIcon } from './IIcon'

export const QrCode:React.FC<IIcon> = ({
  width = '2.4',
  height = '2.4',
  color = '#5C5C5C',
  className = '',
  ...innerProps
}) => (
  <svg {...innerProps} className={className} width={`${width}rem`} height={`${height}rem`} viewBox="0 0 24 24"
       fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.75 3.75H5.25C4.42157 3.75 3.75 4.42157 3.75 5.25V9.75C3.75 10.5784 4.42157 11.25 5.25 11.25H9.75C10.5784 11.25 11.25 10.5784 11.25 9.75V5.25C11.25 4.42157 10.5784 3.75 9.75 3.75Z"
      fill={color}/>
    <path
      d="M9.75 12.75H5.25C4.42157 12.75 3.75 13.4216 3.75 14.25V18.75C3.75 19.5784 4.42157 20.25 5.25 20.25H9.75C10.5784 20.25 11.25 19.5784 11.25 18.75V14.25C11.25 13.4216 10.5784 12.75 9.75 12.75Z"
      fill={color}/>
    <path
      d="M18.75 3.75H14.25C13.4216 3.75 12.75 4.42157 12.75 5.25V9.75C12.75 10.5784 13.4216 11.25 14.25 11.25H18.75C19.5784 11.25 20.25 10.5784 20.25 9.75V5.25C20.25 4.42157 19.5784 3.75 18.75 3.75Z"
      fill={color}/>
    <path
      d="M13.5 17.25C13.6989 17.25 13.8897 17.171 14.0303 17.0303C14.171 16.8897 14.25 16.6989 14.25 16.5V13.5C14.25 13.3011 14.171 13.1103 14.0303 12.9697C13.8897 12.829 13.6989 12.75 13.5 12.75C13.3011 12.75 13.1103 12.829 12.9697 12.9697C12.829 13.1103 12.75 13.3011 12.75 13.5V16.5C12.75 16.6989 12.829 16.8897 12.9697 17.0303C13.1103 17.171 13.3011 17.25 13.5 17.25Z"
      fill={color}/>
    <path
      d="M19.5 14.25H17.25V13.5C17.25 13.3011 17.171 13.1103 17.0303 12.9697C16.8897 12.829 16.6989 12.75 16.5 12.75C16.3011 12.75 16.1103 12.829 15.9697 12.9697C15.829 13.1103 15.75 13.3011 15.75 13.5V18.75H13.5C13.3011 18.75 13.1103 18.829 12.9697 18.9697C12.829 19.1103 12.75 19.3011 12.75 19.5C12.75 19.6989 12.829 19.8897 12.9697 20.0303C13.1103 20.171 13.3011 20.25 13.5 20.25H16.5C16.6989 20.25 16.8897 20.171 17.0303 20.0303C17.171 19.8897 17.25 19.6989 17.25 19.5V15.75H19.5C19.6989 15.75 19.8897 15.671 20.0303 15.5303C20.171 15.3897 20.25 15.1989 20.25 15C20.25 14.8011 20.171 14.6103 20.0303 14.4697C19.8897 14.329 19.6989 14.25 19.5 14.25Z"
      fill={color}/>
    <path
      d="M19.5 17.25C19.3011 17.25 19.1103 17.329 18.9697 17.4697C18.829 17.6103 18.75 17.8011 18.75 18V19.5C18.75 19.6989 18.829 19.8897 18.9697 20.0303C19.1103 20.171 19.3011 20.25 19.5 20.25C19.6989 20.25 19.8897 20.171 20.0303 20.0303C20.171 19.8897 20.25 19.6989 20.25 19.5V18C20.25 17.8011 20.171 17.6103 20.0303 17.4697C19.8897 17.329 19.6989 17.25 19.5 17.25Z"
      fill={color}/>
  </svg>
)